
import { defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "widget-12",
  props: {
    widgetClasses: String,
    widgetColor: String,
    chartHeight: String,
    amount: String,
    groupMid: Array,
  },
  setup(props) {
    const sparklineData = ref([]);
    const chartOptionsSpark2 = ref({
      chart: {
        type: "area",
        height: 200,
        sparkline: {
          enabled: false,
        },
      },
      theme: {
        palette: "palette5", // upto palette1
      },
      stroke: {
        curve: "straight",
      },
      fill: {
        opacity: 0.8,
      },
      xaxis: {
        type: "datetime",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: "#8e8da4",
          },
          offsetY: -7,
          offsetX: 0,
        },
      },
      yaxis: {
        show: false,
        min: 0,
        lines: {
          show: false,
        },
      },
      grid: {
        borderColor: "#1c325e",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        strokeDashArray: 4,
      },
      //colors: ["#3E97FF"],
    });
    const seriesSpark2 = ref([
      {
        data: sparklineData.value,
        show: false,
      },
    ]);

    onMounted(() => {
      setTimeout(() => {
        getSeries();
      }, 1000);
    });

    const store = useStore();
    const sum = ref(0);
    const getSeries = async () => {
      try {
        let url = `reports/chargebacks/incoming.merchants?fields=new_label,count,amount,group_id&sort=month_no:day,ASC&offset=0&limit=1000`;

        if (props.groupMid && props.groupMid.length === 1) {
          url = `${url}&group_id=${props.groupMid[0]}`;
        } else if (props.groupMid && props.groupMid.length === 2) {
          url = `${url}&merchant_id=${props.groupMid[1]}`;
        } else {
          url = `${url}&group_id=IN${store.getters.currentUser.data.group_owners}`;
        }

        const { data } = await ApiService.get(
          url
          // `reports/chargebacks/incoming.monthly?group_id=2670`
        );
        if (data.success) {
          const series = data.data.map((ele) => ({
            x: ele.new_label,
            y: ele.amount,
          }));
          seriesSpark2.value = [
            {
              data: series,
              show: false,
            },
          ];

          sum.value = series.reduce(
            (partialSum, a) => partialSum + Number(a),
            0
          );

          chartOptionsSpark2.value = {
            chart: {
              type: "area",
              height: 200,
              sparkline: {
                enabled: false,
              },
            },
            theme: {
              palette: "palette1", // upto palette5
            },
            stroke: {
              curve: "straight",
            },
            fill: {
              opacity: 0.8,
            },
            xaxis: {
              type: "datetime",
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
              labels: {
                style: {
                  colors: "#8e8da4",
                },
                offsetY: -7,
                offsetX: 0,
              },
            },
            yaxis: {
              show: false,
              min: 0,
              lines: {
                show: false,
              },
            },
            grid: {
              borderColor: "#1c325e",
              xaxis: {
                lines: {
                  show: true,
                },
              },
              yaxis: {
                lines: {
                  show: false,
                },
              },
              strokeDashArray: 4,
            },
            //colors: ["#3E97FF"],
          };
        } else {
          seriesSpark2.value = [
            {
              data: [],
              show: false,
            },
          ];
        }
      } catch (e) {
        seriesSpark2.value = [
          {
            data: [],
            show: false,
          },
        ];
      }
    };

    watch(
      () => props.groupMid,
      () => {
        getSeries();
      }
    );

    return {
      chartOptionsSpark2,
      seriesSpark2,
    };
  },
});
